import type { Container } from "pixi.js";
import { CaptainView } from "../views/character/CaptainView";
import type { SlotCannonHook } from "./SlotCannonHook";

/** Adds slot-cannon's members to the shell's hook: the captain, found on the stage. */
export function installSlotCannonHook(input: { hook: object; stage: Container }): void {
  const captain = find(input.stage, CaptainView);
  const members: SlotCannonHook = {
    getCaptain: () => ({ ...(captain?.state ?? { loaded: false, wins: 0, bigWins: 0 }) }),
  };
  Object.assign(input.hook, members);
}

/** The first node of `type` under `node`, depth first. */
function find<T>(node: Container, type: abstract new (...args: never[]) => T): T | null {
  if (node instanceof type) return node;
  for (const child of node.children) {
    const found = find(child, type);
    if (found) return found;
  }
  return null;
}
